@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(263_802_646)
internal val Res.string.home__recently_released_games: StringResource by lazy {
      StringResource("string:home__recently_released_games", "home__recently_released_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17303, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16183, 53),
      ))
    }

@delegate:ResourceContentHash(1_415_670_972)
internal val Res.string.home__release_today: StringResource by lazy {
      StringResource("string:home__release_today", "home__release_today", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17353, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16237, 35),
      ))
    }

@delegate:ResourceContentHash(659_067_246)
internal val Res.string.home__release_tomorrow: StringResource by lazy {
      StringResource("string:home__release_tomorrow", "home__release_tomorrow", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17389, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16273, 42),
      ))
    }

@delegate:ResourceContentHash(-962_762_456)
internal val Res.string.home__section_error: StringResource by lazy {
      StringResource("string:home__section_error", "home__section_error", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17428, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16316, 63),
      ))
    }

@delegate:ResourceContentHash(-1_123_246_097)
internal val Res.string.home__see_all: StringResource by lazy {
      StringResource("string:home__see_all", "home__see_all", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17504, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16380, 33),
      ))
    }

@delegate:ResourceContentHash(-71_770_541)
internal val Res.string.home__upcoming_games: StringResource by lazy {
      StringResource("string:home__upcoming_games", "home__upcoming_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17542, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16414, 44),
      ))
    }

@delegate:ResourceContentHash(522_420_586)
internal val Res.string.library__add_to_backlog: StringResource by lazy {
      StringResource("string:library__add_to_backlog", "library__add_to_backlog", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17583, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16459, 51),
      ))
    }

@delegate:ResourceContentHash(-37_318_223)
internal val Res.string.library__add_to_library: StringResource by lazy {
      StringResource("string:library__add_to_library", "library__add_to_library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17643, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16511, 59),
      ))
    }

@delegate:ResourceContentHash(-600_875_207)
internal val Res.string.library__add_to_playing: StringResource by lazy {
      StringResource("string:library__add_to_playing", "library__add_to_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17711, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16571, 51),
      ))
    }

@delegate:ResourceContentHash(209_227_226)
internal val Res.string.library__cancel: StringResource by lazy {
      StringResource("string:library__cancel", "library__cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17771, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16623, 31),
      ))
    }

@delegate:ResourceContentHash(-1_860_727_459)
internal val Res.string.library__clear_review_confirm: StringResource by lazy {
      StringResource("string:library__clear_review_confirm", "library__clear_review_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17807, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16655, 57),
      ))
    }

@delegate:ResourceContentHash(664_834_162)
internal val Res.string.library__clear_review_message: StringResource by lazy {
      StringResource("string:library__clear_review_message", "library__clear_review_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 17865, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16713, 161),
      ))
    }

@delegate:ResourceContentHash(-895_187_181)
internal val Res.string.library__clear_review_title: StringResource by lazy {
      StringResource("string:library__clear_review_title", "library__clear_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18027, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16875, 59),
      ))
    }

@delegate:ResourceContentHash(-65_594_240)
internal val Res.string.library__completion_100: StringResource by lazy {
      StringResource("string:library__completion_100", "library__completion_100", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18095, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16935, 39),
      ))
    }

@delegate:ResourceContentHash(-329_956_180)
internal val Res.string.library__completion_main_plus_sides: StringResource by lazy {
      StringResource("string:library__completion_main_plus_sides", "library__completion_main_plus_sides", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18135, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16975, 59),
      ))
    }

@delegate:ResourceContentHash(-2_064_960_158)
internal val Res.string.library__completion_main_story: StringResource by lazy {
      StringResource("string:library__completion_main_story", "library__completion_main_story", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18207, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17035, 54),
      ))
    }

@delegate:ResourceContentHash(-85_520_206)
internal val Res.string.library__completion_status: StringResource by lazy {
      StringResource("string:library__completion_status", "library__completion_status", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18389, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17213, 58),
      ))
    }

@delegate:ResourceContentHash(-1_200_798_324)
internal val Res.string.library__completion_status_description: StringResource by lazy {
      StringResource("string:library__completion_status_description", "library__completion_status_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18270, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17090, 122),
      ))
    }

@delegate:ResourceContentHash(-2_020_441_353)
internal val Res.string.library__dates: StringResource by lazy {
      StringResource("string:library__dates", "library__dates", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18571, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17375, 30),
      ))
    }

@delegate:ResourceContentHash(-1_233_535_024)
internal val Res.string.library__dates_description: StringResource by lazy {
      StringResource("string:library__dates_description", "library__dates_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18456, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17272, 102),
      ))
    }

@delegate:ResourceContentHash(1_735_629_335)
internal val Res.string.library__delete: StringResource by lazy {
      StringResource("string:library__delete", "library__delete", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18602, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17406, 31),
      ))
    }

@delegate:ResourceContentHash(-1_568_328_240)
internal val Res.string.library__disabled_fields_message: StringResource by lazy {
      StringResource("string:library__disabled_fields_message", "library__disabled_fields_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18638, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17438, 100),
      ))
    }

@delegate:ResourceContentHash(1_173_171_899)
internal val Res.string.library__edit_entry: StringResource by lazy {
      StringResource("string:library__edit_entry", "library__edit_entry", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18755, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17539, 39),
      ))
    }

@delegate:ResourceContentHash(-176_415_323)
internal val Res.string.library__edit_in_library: StringResource by lazy {
      StringResource("string:library__edit_in_library", "library__edit_in_library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18803, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17579, 56),
      ))
    }

@delegate:ResourceContentHash(1_313_775_488)
internal val Res.string.library__edit_review: StringResource by lazy {
      StringResource("string:library__edit_review", "library__edit_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18868, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17636, 44),
      ))
    }

@delegate:ResourceContentHash(-1_685_232_883)
internal val Res.string.library__edition: StringResource by lazy {
      StringResource("string:library__edition", "library__edition", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19050, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17794, 36),
      ))
    }

@delegate:ResourceContentHash(-1_832_229_604)
internal val Res.string.library__edition_description: StringResource by lazy {
      StringResource("string:library__edition_description", "library__edition_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 18925, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17681, 112),
      ))
    }

@delegate:ResourceContentHash(971_377_083)
internal val Res.string.library__empty_all: StringResource by lazy {
      StringResource("string:library__empty_all", "library__empty_all", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19087, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17831, 90),
      ))
    }

@delegate:ResourceContentHash(-2_020_414_484)
internal val Res.string.library__end_date: StringResource by lazy {
      StringResource("string:library__end_date", "library__end_date", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19194, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17922, 37),
      ))
    }

@delegate:ResourceContentHash(2_126_069_991)
internal val Res.string.library__error_select_status: StringResource by lazy {
      StringResource("string:library__error_select_status", "library__error_select_status", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19236, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17960, 68),
      ))
    }

@delegate:ResourceContentHash(1_909_400_326)
internal val Res.string.library__hours: StringResource by lazy {
      StringResource("string:library__hours", "library__hours", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19343, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18071, 30),
      ))
    }

@delegate:ResourceContentHash(805_026_338)
internal val Res.string.library__hours_played: StringResource by lazy {
      StringResource("string:library__hours_played", "library__hours_played", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19301, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18029, 41),
      ))
    }

@delegate:ResourceContentHash(586_549_882)
internal val Res.string.library__no_edition: StringResource by lazy {
      StringResource("string:library__no_edition", "library__no_edition", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19370, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18102, 55),
      ))
    }

@delegate:ResourceContentHash(-2_112_238_308)
internal val Res.string.library__open_review: StringResource by lazy {
      StringResource("string:library__open_review", "library__open_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19434, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18158, 44),
      ))
    }

@delegate:ResourceContentHash(-756_201_972)
internal val Res.string.library__overall_rating: StringResource by lazy {
      StringResource("string:library__overall_rating", "library__overall_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19483, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18203, 51),
      ))
    }

@delegate:ResourceContentHash(-127_344_033)
internal val Res.string.library__overall_review: StringResource by lazy {
      StringResource("string:library__overall_review", "library__overall_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19639, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18347, 51),
      ))
    }

@delegate:ResourceContentHash(-1_430_306_881)
internal val Res.string.library__overall_review_description: StringResource by lazy {
      StringResource("string:library__overall_review_description", "library__overall_review_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19539, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18255, 91),
      ))
    }

@delegate:ResourceContentHash(1_488_743_818)
internal val Res.string.library__owned: StringResource by lazy {
      StringResource("string:library__owned", "library__owned", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19798, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18494, 30),
      ))
    }

@delegate:ResourceContentHash(1_996_365_349)
internal val Res.string.library__owned_description: StringResource by lazy {
      StringResource("string:library__owned_description", "library__owned_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19703, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18399, 94),
      ))
    }

@delegate:ResourceContentHash(1_000_811_706)
internal val Res.string.library__platform_owned: StringResource by lazy {
      StringResource("string:library__platform_owned", "library__platform_owned", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19833, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18525, 47),
      ))
    }

@delegate:ResourceContentHash(-1_263_405_668)
internal val Res.string.library__platforms: StringResource by lazy {
      StringResource("string:library__platforms", "library__platforms", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19996, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18672, 38),
      ))
    }

@delegate:ResourceContentHash(-208_006_405)
internal val Res.string.library__platforms_description: StringResource by lazy {
      StringResource("string:library__platforms_description", "library__platforms_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 19881, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18573, 98),
      ))
    }

@delegate:ResourceContentHash(-503_778_154)
internal val Res.string.library__played_time: StringResource by lazy {
      StringResource("string:library__played_time", "library__played_time", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20152, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18820, 44),
      ))
    }

@delegate:ResourceContentHash(-626_630_915)
internal val Res.string.library__played_time_description: StringResource by lazy {
      StringResource("string:library__played_time_description", "library__played_time_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20039, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18711, 108),
      ))
    }

@delegate:ResourceContentHash(-149_207_855)
internal val Res.string.library__rating: StringResource by lazy {
      StringResource("string:library__rating", "library__rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20405, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19061, 47),
      ))
    }

@delegate:ResourceContentHash(897_097_486)
internal val Res.string.library__rating_average_description: StringResource by lazy {
      StringResource("string:library__rating_average_description", "library__rating_average_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20201, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18865, 99),
      ))
    }

@delegate:ResourceContentHash(-997_163_947)
internal val Res.string.library__rating_description: StringResource by lazy {
      StringResource("string:library__rating_description", "library__rating_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20301, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18965, 95),
      ))
    }

@delegate:ResourceContentHash(1_038_138_792)
internal val Res.string.library__remove_from_backlog: StringResource by lazy {
      StringResource("string:library__remove_from_backlog", "library__remove_from_backlog", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20449, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19109, 64),
      ))
    }

@delegate:ResourceContentHash(-1_611_900_213)
internal val Res.string.library__remove_from_playing: StringResource by lazy {
      StringResource("string:library__remove_from_playing", "library__remove_from_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20514, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19174, 64),
      ))
    }

@delegate:ResourceContentHash(-406_311_696)
internal val Res.string.library__review: StringResource by lazy {
      StringResource("string:library__review", "library__review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21183, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19803, 31),
      ))
    }

@delegate:ResourceContentHash(-6_242_949)
internal val Res.string.library__review_add_section: StringResource by lazy {
      StringResource("string:library__review_add_section", "library__review_add_section", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20579, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19239, 51),
      ))
    }

@delegate:ResourceContentHash(-1_316_258_709)
internal val Res.string.library__review_custom_section: StringResource by lazy {
      StringResource("string:library__review_custom_section", "library__review_custom_section", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20639, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19291, 58),
      ))
    }

@delegate:ResourceContentHash(-1_829_612_823)
internal val Res.string.library__review_description: StringResource by lazy {
      StringResource("string:library__review_description", "library__review_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20710, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19350, 115),
      ))
    }

@delegate:ResourceContentHash(-126_181_748)
internal val Res.string.library__review_remove_section: StringResource by lazy {
      StringResource("string:library__review_remove_section", "library__review_remove_section", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20834, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19466, 58),
      ))
    }

@delegate:ResourceContentHash(-1_304_944_195)
internal val Res.string.library__review_sections: StringResource by lazy {
      StringResource("string:library__review_sections", "library__review_sections", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21046, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19678, 52),
      ))
    }

@delegate:ResourceContentHash(-1_615_269_657)
internal val Res.string.library__review_sections_description: StringResource by lazy {
      StringResource("string:library__review_sections_description", "library__review_sections_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 20893, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19525, 152),
      ))
    }

@delegate:ResourceContentHash(1_184_873_495)
internal val Res.string.library__review_spoiler: StringResource by lazy {
      StringResource("string:library__review_spoiler", "library__review_spoiler", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21111, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19731, 71),
      ))
    }

@delegate:ResourceContentHash(313_676_757)
internal val Res.string.library__save: StringResource by lazy {
      StringResource("string:library__save", "library__save", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21512, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20096, 29),
      ))
    }

@delegate:ResourceContentHash(901_985_338)
internal val Res.string.library__save_and_continue: StringResource by lazy {
      StringResource("string:library__save_and_continue", "library__save_and_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21223, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19835, 58),
      ))
    }

@delegate:ResourceContentHash(-1_010_024_138)
internal val Res.string.library__save_before_review_message: StringResource by lazy {
      StringResource("string:library__save_before_review_message", "library__save_before_review_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21282, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19894, 135),
      ))
    }

@delegate:ResourceContentHash(-1_800_664_746)
internal val Res.string.library__save_before_review_title: StringResource by lazy {
      StringResource("string:library__save_before_review_title", "library__save_before_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21442, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20030, 65),
      ))
    }

@delegate:ResourceContentHash(1_684_992_061)
internal val Res.string.library__section: StringResource by lazy {
      StringResource("string:library__section", "library__section", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21846, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20410, 36),
      ))
    }

@delegate:ResourceContentHash(-1_200_942_654)
internal val Res.string.library__section_abandoned: StringResource by lazy {
      StringResource("string:library__section_abandoned", "library__section_abandoned", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21542, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20126, 46),
      ))
    }

@delegate:ResourceContentHash(924_770_688)
internal val Res.string.library__section_backlog: StringResource by lazy {
      StringResource("string:library__section_backlog", "library__section_backlog", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21593, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20173, 44),
      ))
    }

@delegate:ResourceContentHash(1_917_863_195)
internal val Res.string.library__section_completed: StringResource by lazy {
      StringResource("string:library__section_completed", "library__section_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21638, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20218, 46),
      ))
    }

@delegate:ResourceContentHash(332_652_180)
internal val Res.string.library__section_paused: StringResource by lazy {
      StringResource("string:library__section_paused", "library__section_paused", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21689, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20265, 39),
      ))
    }

@delegate:ResourceContentHash(1_342_097_219)
internal val Res.string.library__section_playing: StringResource by lazy {
      StringResource("string:library__section_playing", "library__section_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21733, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20305, 44),
      ))
    }

@delegate:ResourceContentHash(288_257_982)
internal val Res.string.library__section_review: StringResource by lazy {
      StringResource("string:library__section_review", "library__section_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21778, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20350, 59),
      ))
    }

@delegate:ResourceContentHash(991_998_606)
internal val Res.string.library__select_edition: StringResource by lazy {
      StringResource("string:library__select_edition", "library__select_edition", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21883, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20447, 51),
      ))
    }

@delegate:ResourceContentHash(1_229_491_259)
internal val Res.string.library__standard_edition: StringResource by lazy {
      StringResource("string:library__standard_edition", "library__standard_edition", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21939, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20499, 57),
      ))
    }

@delegate:ResourceContentHash(826_037_740)
internal val Res.string.library__start_date: StringResource by lazy {
      StringResource("string:library__start_date", "library__start_date", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 21997, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20557, 43),
      ))
    }

@delegate:ResourceContentHash(786_777_888)
internal val Res.string.library__status: StringResource by lazy {
      StringResource("string:library__status", "library__status", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22165, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20713, 31),
      ))
    }

@delegate:ResourceContentHash(1_057_628_431)
internal val Res.string.library__status_description: StringResource by lazy {
      StringResource("string:library__status_description", "library__status_description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22045, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20601, 111),
      ))
    }

@delegate:ResourceContentHash(-393_594_591)
internal val Res.string.library__write_review: StringResource by lazy {
      StringResource("string:library__write_review", "library__write_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22197, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20745, 49),
      ))
    }

@delegate:ResourceContentHash(2_016_139_320)
internal val Res.string.lists__actions: StringResource by lazy {
      StringResource("string:lists__actions", "lists__actions", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22255, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20795, 38),
      ))
    }

@delegate:ResourceContentHash(-507_343_390)
internal val Res.string.lists__add_comment: StringResource by lazy {
      StringResource("string:lists__add_comment", "lists__add_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22302, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20834, 38),
      ))
    }

@delegate:ResourceContentHash(-1_404_240_035)
internal val Res.string.lists__add_games: StringResource by lazy {
      StringResource("string:lists__add_games", "lists__add_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22341, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20873, 36),
      ))
    }

@delegate:ResourceContentHash(-184_956_106)
internal val Res.string.lists__add_to_list: StringResource by lazy {
      StringResource("string:lists__add_to_list", "lists__add_to_list", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22386, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20910, 42),
      ))
    }

@delegate:ResourceContentHash(-1_219_091_995)
internal val Res.string.lists__delete: StringResource by lazy {
      StringResource("string:lists__delete", "lists__delete", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22599, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21091, 37),
      ))
    }

@delegate:ResourceContentHash(203_336_564)
internal val Res.string.lists__delete_confirm: StringResource by lazy {
      StringResource("string:lists__delete_confirm", "lists__delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22441, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20953, 137),
      ))
    }

@delegate:ResourceContentHash(-1_719_265_545)
internal val Res.string.lists__description: StringResource by lazy {
      StringResource("string:lists__description", "lists__description", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22641, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21129, 42),
      ))
    }

@delegate:ResourceContentHash(279_777_794)
internal val Res.string.lists__edit: StringResource by lazy {
      StringResource("string:lists__edit", "lists__edit", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22684, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21172, 31),
      ))
    }

@delegate:ResourceContentHash(269_623_227)
internal val Res.string.lists__empty: StringResource by lazy {
      StringResource("string:lists__empty", "lists__empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22724, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21204, 40),
      ))
    }

@delegate:ResourceContentHash(-699_378_132)
internal val Res.string.lists__move_down: StringResource by lazy {
      StringResource("string:lists__move_down", "lists__move_down", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22773, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21245, 36),
      ))
    }

@delegate:ResourceContentHash(-9_438_808)
internal val Res.string.lists__move_up: StringResource by lazy {
      StringResource("string:lists__move_up", "lists__move_up", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22814, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21282, 34),
      ))
    }

@delegate:ResourceContentHash(-1_920_083_597)
internal val Res.string.lists__name: StringResource by lazy {
      StringResource("string:lists__name", "lists__name", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22849, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21317, 27),
      ))
    }

@delegate:ResourceContentHash(-367_234_059)
internal val Res.string.lists__new: StringResource by lazy {
      StringResource("string:lists__new", "lists__new", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22877, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21345, 30),
      ))
    }

@delegate:ResourceContentHash(954_994_588)
internal val Res.string.lists__no_games: StringResource by lazy {
      StringResource("string:lists__no_games", "lists__no_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22912, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21376, 59),
      ))
    }

@delegate:ResourceContentHash(-261_383_636)
internal val Res.string.lists__not_available: StringResource by lazy {
      StringResource("string:lists__not_available", "lists__not_available", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 22984, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21436, 64),
      ))
    }

@delegate:ResourceContentHash(-7_800_481)
internal val Res.string.lists__note: StringResource by lazy {
      StringResource("string:lists__note", "lists__note", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23057, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21501, 27),
      ))
    }

@delegate:ResourceContentHash(826_235_859)
internal val Res.string.lists__private: StringResource by lazy {
      StringResource("string:lists__private", "lists__private", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23173, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21629, 38),
      ))
    }

@delegate:ResourceContentHash(-1_605_149_092)
internal val Res.string.lists__private_hint: StringResource by lazy {
      StringResource("string:lists__private_hint", "lists__private_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23085, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21529, 99),
      ))
    }

@delegate:ResourceContentHash(-539_117_588)
internal val Res.string.lists__ranked: StringResource by lazy {
      StringResource("string:lists__ranked", "lists__ranked", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23335, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21779, 37),
      ))
    }

@delegate:ResourceContentHash(1_296_750_488)
internal val Res.string.lists__ranked_hint: StringResource by lazy {
      StringResource("string:lists__ranked_hint", "lists__ranked_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23216, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21668, 110),
      ))
    }

@delegate:ResourceContentHash(-1_861_829_295)
internal val Res.string.lists__remove_game: StringResource by lazy {
      StringResource("string:lists__remove_game", "lists__remove_game", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23385, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21817, 50),
      ))
    }

@delegate:ResourceContentHash(313_676_757)
internal val Res.string.lists__save: StringResource by lazy {
      StringResource("string:lists__save", "lists__save", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23440, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21868, 27),
      ))
    }

@delegate:ResourceContentHash(493_571_929)
internal val Res.string.nav__calendar: StringResource by lazy {
      StringResource("string:nav__calendar", "nav__calendar", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23468, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21896, 33),
      ))
    }

@delegate:ResourceContentHash(1_717_443_042)
internal val Res.string.nav__detail_placeholder: StringResource by lazy {
      StringResource("string:nav__detail_placeholder", "nav__detail_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23506, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21930, 71),
      ))
    }

@delegate:ResourceContentHash(-1_037_639_145)
internal val Res.string.nav__discover: StringResource by lazy {
      StringResource("string:nav__discover", "nav__discover", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23582, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22002, 33),
      ))
    }

@delegate:ResourceContentHash(-1_625_262_006)
internal val Res.string.nav__events: StringResource by lazy {
      StringResource("string:nav__events", "nav__events", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 23612, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22036, 27),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("home__recently_released_games", Res.string.home__recently_released_games)
  map.put("home__release_today", Res.string.home__release_today)
  map.put("home__release_tomorrow", Res.string.home__release_tomorrow)
  map.put("home__section_error", Res.string.home__section_error)
  map.put("home__see_all", Res.string.home__see_all)
  map.put("home__upcoming_games", Res.string.home__upcoming_games)
  map.put("library__add_to_backlog", Res.string.library__add_to_backlog)
  map.put("library__add_to_library", Res.string.library__add_to_library)
  map.put("library__add_to_playing", Res.string.library__add_to_playing)
  map.put("library__cancel", Res.string.library__cancel)
  map.put("library__clear_review_confirm", Res.string.library__clear_review_confirm)
  map.put("library__clear_review_message", Res.string.library__clear_review_message)
  map.put("library__clear_review_title", Res.string.library__clear_review_title)
  map.put("library__completion_100", Res.string.library__completion_100)
  map.put("library__completion_main_plus_sides", Res.string.library__completion_main_plus_sides)
  map.put("library__completion_main_story", Res.string.library__completion_main_story)
  map.put("library__completion_status", Res.string.library__completion_status)
  map.put("library__completion_status_description", Res.string.library__completion_status_description)
  map.put("library__dates", Res.string.library__dates)
  map.put("library__dates_description", Res.string.library__dates_description)
  map.put("library__delete", Res.string.library__delete)
  map.put("library__disabled_fields_message", Res.string.library__disabled_fields_message)
  map.put("library__edit_entry", Res.string.library__edit_entry)
  map.put("library__edit_in_library", Res.string.library__edit_in_library)
  map.put("library__edit_review", Res.string.library__edit_review)
  map.put("library__edition", Res.string.library__edition)
  map.put("library__edition_description", Res.string.library__edition_description)
  map.put("library__empty_all", Res.string.library__empty_all)
  map.put("library__end_date", Res.string.library__end_date)
  map.put("library__error_select_status", Res.string.library__error_select_status)
  map.put("library__hours", Res.string.library__hours)
  map.put("library__hours_played", Res.string.library__hours_played)
  map.put("library__no_edition", Res.string.library__no_edition)
  map.put("library__open_review", Res.string.library__open_review)
  map.put("library__overall_rating", Res.string.library__overall_rating)
  map.put("library__overall_review", Res.string.library__overall_review)
  map.put("library__overall_review_description", Res.string.library__overall_review_description)
  map.put("library__owned", Res.string.library__owned)
  map.put("library__owned_description", Res.string.library__owned_description)
  map.put("library__platform_owned", Res.string.library__platform_owned)
  map.put("library__platforms", Res.string.library__platforms)
  map.put("library__platforms_description", Res.string.library__platforms_description)
  map.put("library__played_time", Res.string.library__played_time)
  map.put("library__played_time_description", Res.string.library__played_time_description)
  map.put("library__rating", Res.string.library__rating)
  map.put("library__rating_average_description", Res.string.library__rating_average_description)
  map.put("library__rating_description", Res.string.library__rating_description)
  map.put("library__remove_from_backlog", Res.string.library__remove_from_backlog)
  map.put("library__remove_from_playing", Res.string.library__remove_from_playing)
  map.put("library__review", Res.string.library__review)
  map.put("library__review_add_section", Res.string.library__review_add_section)
  map.put("library__review_custom_section", Res.string.library__review_custom_section)
  map.put("library__review_description", Res.string.library__review_description)
  map.put("library__review_remove_section", Res.string.library__review_remove_section)
  map.put("library__review_sections", Res.string.library__review_sections)
  map.put("library__review_sections_description", Res.string.library__review_sections_description)
  map.put("library__review_spoiler", Res.string.library__review_spoiler)
  map.put("library__save", Res.string.library__save)
  map.put("library__save_and_continue", Res.string.library__save_and_continue)
  map.put("library__save_before_review_message", Res.string.library__save_before_review_message)
  map.put("library__save_before_review_title", Res.string.library__save_before_review_title)
  map.put("library__section", Res.string.library__section)
  map.put("library__section_abandoned", Res.string.library__section_abandoned)
  map.put("library__section_backlog", Res.string.library__section_backlog)
  map.put("library__section_completed", Res.string.library__section_completed)
  map.put("library__section_paused", Res.string.library__section_paused)
  map.put("library__section_playing", Res.string.library__section_playing)
  map.put("library__section_review", Res.string.library__section_review)
  map.put("library__select_edition", Res.string.library__select_edition)
  map.put("library__standard_edition", Res.string.library__standard_edition)
  map.put("library__start_date", Res.string.library__start_date)
  map.put("library__status", Res.string.library__status)
  map.put("library__status_description", Res.string.library__status_description)
  map.put("library__write_review", Res.string.library__write_review)
  map.put("lists__actions", Res.string.lists__actions)
  map.put("lists__add_comment", Res.string.lists__add_comment)
  map.put("lists__add_games", Res.string.lists__add_games)
  map.put("lists__add_to_list", Res.string.lists__add_to_list)
  map.put("lists__delete", Res.string.lists__delete)
  map.put("lists__delete_confirm", Res.string.lists__delete_confirm)
  map.put("lists__description", Res.string.lists__description)
  map.put("lists__edit", Res.string.lists__edit)
  map.put("lists__empty", Res.string.lists__empty)
  map.put("lists__move_down", Res.string.lists__move_down)
  map.put("lists__move_up", Res.string.lists__move_up)
  map.put("lists__name", Res.string.lists__name)
  map.put("lists__new", Res.string.lists__new)
  map.put("lists__no_games", Res.string.lists__no_games)
  map.put("lists__not_available", Res.string.lists__not_available)
  map.put("lists__note", Res.string.lists__note)
  map.put("lists__private", Res.string.lists__private)
  map.put("lists__private_hint", Res.string.lists__private_hint)
  map.put("lists__ranked", Res.string.lists__ranked)
  map.put("lists__ranked_hint", Res.string.lists__ranked_hint)
  map.put("lists__remove_game", Res.string.lists__remove_game)
  map.put("lists__save", Res.string.lists__save)
  map.put("nav__calendar", Res.string.nav__calendar)
  map.put("nav__detail_placeholder", Res.string.nav__detail_placeholder)
  map.put("nav__discover", Res.string.nav__discover)
  map.put("nav__events", Res.string.nav__events)
}
